var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2252 26.4172H0.931885V10.3291C0.931885 4.62302 5.58979 0 11.339 0H22.2252C29.5714 0 35.5335 5.91746 35.5335 13.2086C35.5335 20.4998 29.5714 26.4172 22.2252 26.4172Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5785 10.5669C5.05746 7.31757 4.52513 4.09467 5.11069 2.06055C2.58211 3.93617 0.931885 6.94773 0.931885 10.3291V26.4172H22.2252C25.3659 26.4172 28.2405 25.3341 30.503 23.5377C29.3851 15.7183 20.4685 14.9786 11.5785 10.5669Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.931885 13.2085V26.4171V30.1683C0.931885 34.5008 5.53656 37.3274 9.44921 35.399L10.7268 34.7649C17.1148 31.5949 16.4494 22.3489 9.68875 20.1034C4.84453 18.5184 0.931885 17.4617 0.931885 13.2085Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.936 0C14.4798 1.71712 17.7803 3.88333 24.8869 5.28344C28.9859 6.10238 32.3129 7.66099 34.9746 9.43095C33.351 3.989 28.2406 0 22.2252 0H12.936Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.6667,
    y1: 14.1972,
    x2: 24.5959,
    y2: 4.93092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 11.2174,
    y1: 21.7183,
    x2: 17.2614,
    y2: 13.2952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 4.49095,
    y1: 35.9999,
    x2: 10.2898,
    y2: 21.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C31D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#2880FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 28.2464,
    y1: 2.19718,
    x2: 25.3796,
    y2: 6.10512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#10DCC6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.262151329489c858f7f5bacb6476459f.svg";
export { ForwardRef as ReactComponent };